<template>
  <div class="" >
      <div class="d-block text-center">
        <h3>場次選擇</h3>
      </div>

      <div class="form-group row" style="max-width: 500px">
        <div class="col-sm-12">

          <div v-for="(event,index) in Events" :key="index">
            活動名稱:{{event.Name}}

            <table class="table table-hover" id="tblMain">
              <thead class="thead-light">
              <tr>
                <th>場次名稱</th>
                <th>類型</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in event.EventItems" :key="index">
                <td width="200px">
                  <a role="button" class="btn btn-primary" href="#"  @click="btnSelectEvent(event,item)" style="width: 150px">{{item.Name}}</a>

                </td>
                <td width="200px">
                  <div v-if="item.Type===CheckIn_EventItemType_Open">
                    開放型 (不需預先報名)
                  </div>
                  <div v-else-if="item.Type===CheckIn_EventItemType_NeedReg">
                    需先報名
                  </div>
                  <div v-else>
                    XX:{{item.MediaType}}
                  </div>
                </td>
              </tr>
              </tbody>
            </table>

          </div>


        </div>
      </div>
  </div>

</template>



<script>
/**
<DLGEventItemsSelector ref="dlgEventItems" v-on:returnSelect="dlgEventItemsReturnSelect" mode='1' />


editHtmlContent(item){
  this.$refs.dlgEventItems.showModal();
},

 dlgEventItemsReturnSelect(items){
  item.HelpContent.Content=this.$refs.dlgEventItems.htmlContent;
}


 **/
import util from "@/util/util";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import {CheckIn_EventItemType_Open,CheckIn_EventItemType_NeedReg,QueryType_CheckIn_Index_1_Event} from "@/views/checkInAdmin/js/checkInDeclare";
export default {
  props: ['Mode'], //tag  postTitle="hi"  data this.postTitle
  data: function () {
    return {
      CheckIn_EventItemType_Open:CheckIn_EventItemType_Open,
      CheckIn_EventItemType_NeedReg:CheckIn_EventItemType_NeedReg,
      QueryType_CheckIn_Index_1_Event:QueryType_CheckIn_Index_1_Event,
      // type: "",
      formData: {
        Name: "",
        Memo:"",
        EventItems:[],
      },
      Events:[],
    };
  },
  methods: {

    btnSelectEvent(event,eventItem){
      this.$router.push({ name: 'CheckInAdminScanCode', query:
            {
              Event:event,
              EventItem: eventItem,
            } });
    },
    getItem:function(){
      let that=this

      let loader=util.ShowLoading(this);

      apiAdmin.getContentList(this.QueryType_CheckIn_Index_1_Event).then((data)=>{
        that.Events=apiAdmin.initReturnArray(data.data.data);
        util.HideLoading(loader);
      });

    },
  },
  mounted() {
    this.getItem();
  },
}
</script>

<style scoped>

</style>
